export const API_URL = "https://api.staging.kube.money";
export const HOMEPAGEURL = "https://web.sdk.staging.kube.money/";
export const NAGAD_REDIRECT_URL = "https://web.sdk.staging.kube.money/";
export const TRACKING_ID = "G-VL8MGWYWSY";

// https://web.sdk.staging.dana.money/?merchant=683002007104225&order_id=1675TS124744&payment_ref_id=MDIwNTEyNDc0NTAxMi42ODMwMDIwMDcxMDQyMjUuMTY3NVRTMTI0NzQ0LmNjY2IzMDc4NjZlYWVmZmE5NThk&status=Aborted&status_code=9999&message=Not%20a%20Nagad%20account
